
import React, {Component} from 'react'
import getWeb3 from './utils/getWeb3'
import Web3 from 'web3'
import _ from 'lodash';
import variablestore from './variablestore'


var ETH_CLIENT = variablestore.ETH_CLIENT
var myetherescrowABI = variablestore.myetherescrowABI
var myetherescrowAddress = variablestore.myetherescrowAddress
var mee = variablestore.mee
var entitydb = variablestore.entitydb


class Search extends Component {
 
  constructor(props){ 
    super(props)
    this.state = {
      
      col1: [],
      col2: [],
      col3: [],
      Address: "",
      buyerInfo: [],
      sellerInfo: [],
      escrowInfo: [],
      escrowFee: 0
  
    }

  this.handleAddressInput = this.handleAddressInput.bind(this);
  this.handleClick = this.handleClick.bind(this);


  }


  handleClick(compName, e){
    
        console.log(compName);
        this.setState({render:compName,
        buyerInfo: entitydb.getBuyerFullInfo(this.state.Address),
        sellerInfo: entitydb.getSellerFullInfo(this.state.Address),
        escrowInfo: entitydb.getEscrowFullInfo(this.state.Address),
        escrowFee : mee.getEscrowFee(this.state.Address)
      
      });        
  }

  _renderSubComp(){
        switch(this.state.render){
            case 'buyer': return <ViewBuyerInfo buyerinfo={this.state.buyerInfo} Address={this.state.Address}/>
            case 'seller' : return <ViewSellerInfo sellerinfo={this.state.sellerInfo} Address={this.state.Address}/>
            case 'escrow': return <ViewEscrowInfo escrowinfo={this.state.escrowInfo} escrowFee={this.state.escrowFee} Address={this.state.Address}/>
        }
    }

  handleAddressInput(e) {

    this.setState({Address: e.target.value});
  
  }



  componentWillMount(){
    console.log(ETH_CLIENT)

  }



  render() {
    


    return (

      
    <div>
      <div className="body-container">
        
      <table className="full">

          <thead>
            <tr>
              <th>
                <h1 className="header-container">Search</h1>
              </th>
            </tr>

          </thead>
          </table>
      </div>
      <div className="body-container white-bg">
          
          <table>        
        
          
            <tr>
              <td>
                <h2>Input Address:</h2>
                
              </td>
              
            </tr>
          <tr>
            <td> <input className="left input-address input-pad" type="text" placeholder="0x1d30c93f9c5b498ca1d5844bf6dec880756ba14f" onChange={this.handleAddressInput} value={this.state.Address}/></td>
            
          </tr>
          </table>
          <table>
           <tr>
             <td><br/><button className="searchButton" onClick={this.handleClick.bind(this, 'buyer')}><p>Search Buyer Database</p></button></td>
             <td><br/><button className="searchButton" onClick={this.handleClick.bind(this, 'seller')}><p>Search Seller Database</p></button></td>
             <td><br/><button className="searchButton" onClick={this.handleClick.bind(this, 'escrow')}><p>Search Escrow Database</p></button></td>
             </tr>
          
          </table>
      </div>
      <div className="body-container white-bg padding">
        {this._renderSubComp()}


        </div>
      </div>

      
    );
  }
}

export default Search;

class ViewBuyerInfo extends React.Component {
    render(){
        return (
        
        <div>
          Buyer Address: {this.props.Address}<br/>
          Buyer Name: {this.props.buyerinfo[0]}<br/>          
          Buyer Info: {this.props.buyerinfo[1]}<br/>
        </div>
      
      )
    }
}
class ViewSellerInfo extends React.Component {
    render(){
        return (
        
          <div>
          Seller Address: {this.props.Address}<br/>
          Seller Name: {this.props.sellerinfo[0]}<br/>          
          Seller Info: {this.props.sellerinfo[1]}<br/>
          </div>
      )
    }
}

class ViewEscrowInfo extends React.Component {
    render(){
        return (
        
          <div>
          Escrow Address: {this.props.Address}<br/>
          Escrow Name: {this.props.escrowinfo[0]}<br/>          
          Escrow Info: {this.props.escrowinfo[1]}<br/>
          Escrow Fee: {parseFloat(this.props.escrowFee/10).toFixed(1)}%<br/>
          </div>)
    }
}


// WEBPACK FOOTER //
// ./src/Search.js